import { haptic } from '../lib/haptics.js';

/**
 * "Tap to turn on sound."
 *
 * Browsers refuse to play audio until they have seen a user gesture. When that
 * happens the room is connected, the right people are on stage, the rings even
 * move — and it is completely silent. There is no error to show, which makes it
 * the quietest possible failure and the easiest to mistake for a broken server.
 *
 * So it gets the loudest treatment in the product: a full-width bar above
 * everything, in the accent, that cannot be scrolled past.
 */
export function SoundGate({ onEnable }: { onEnable: () => void }) {
  return (
    <div class="soundgate" role="alert">
      <button
        class="soundgate__button"
        onClick={() => {
          haptic('press');
          onEnable();
        }}
      >
        <SpeakerIcon />
        <span>
          <strong>Tap to turn on sound</strong>
          <span class="soundgate__hint">Your browser blocked audio until you tapped</span>
        </span>
      </button>
    </div>
  );
}

function SpeakerIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M11 5 6 9H2v6h4l5 4V5z" />
      <path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a9 9 0 0 1 0 14" />
    </svg>
  );
}
